import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import './NestedPage.scss';
import { PageProps } from '../../entities/ContentProps';

export default function NestedPage({ className, children }: PageProps): React.ReactElement {
  return (
    <div className={classnames('nested-page', className)}>
      <Link to={children.node.fields.slug}>
        <div className="nested-page__title">{children.node.childMdx.frontmatter.title}</div>
      </Link>
    </div>
  );
}
